// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-dashed-labeled';

export const Component = () => (
  <path d='M18.63 4.885v-.958h1.964v.958H18.63Zm5.891-.958V6.37h-.958V4.885H22.08v-.958h2.442Zm0 11.878v3.113h-.958v-3.113h.958Zm0-6.274v3.114h-.958V9.53h.958Zm0 12.548v2.442H22.08v-.958h1.484V22.08h.958Zm-6.37 1.484v.958h-3.927v-.958h3.928Zm-7.854 0v.958H6.37v-.958h3.927Zm-7.854 0v.958H.001V22.08h.958v1.484h1.484ZM.958 15.805v3.113H0v-3.113h.958Zm0-6.274v3.114H0V9.53h.958Zm0-4.646V6.37H0V3.927h1.963v.958H.958ZM3.928.958h13.745v6.897H3.927V.958ZM18.63 8.812V0H2.922v8.813H18.63Z' />
);

export const viewBox = '0 0 25 25';
